import { useMemo } from 'react';
import { HubChallengeCard } from '@/components/Hub/HubChallengeCard';
import { challengesNavIcons } from '@/components/Hub/hubNavIcons';
import { defineHubSection, type HubSectionData } from '@/components/Hub/hubSectionTypes';
import { HUB_CHALLENGES_PATH } from '@/components/Hub/hubRoutes';
import { shuffled } from '@/components/Hub/hubShuffle';
import { CHALLENGES } from '@/pages/Explore/Challenges/challenges';

const MAX_CHALLENGES = 6;

// The only section with no fetch behind it, so it always reports content and the panel's empty
// message can no longer appear.
const useChallengesData = (): HubSectionData => {
    const slides = useMemo(
        () => shuffled(CHALLENGES).slice(0, MAX_CHALLENGES).map(challenge => ({
            id: challenge.slug,
            render: () => (
                <HubChallengeCard
                    slug={challenge.slug}
                    title={challenge.title}
                    url={challenge.url}
                    description={challenge.description}
                    imageUrl={challenge.imageUrl}
                />
            ),
        })),
        [],
    );

    return { slides, isLoading: false, isError: false };
};

export const challengesSection = defineHubSection({
    id: 'challenges',
    title: 'Challenges',
    blurb: 'Take on real-world problems and build skills employers look for.',
    navIcons: challengesNavIcons,
    viewAll: { to: HUB_CHALLENGES_PATH, label: 'View all' },
    endCard: {
        to: HUB_CHALLENGES_PATH,
        heading: 'Check out some more Challenges',
        actionLabel: 'Go to Explore page',
        groundClassName: 'bg-gz-sage-200 dark:bg-gz-sage-300',
        zigzagClassName: 'bg-gz-sage-400 dark:bg-gz-sage-200',
        zigzagOpacityClassName: 'opacity-20 dark:opacity-50',
    },
    itemBasisClassName: 'basis-[86%] sm:basis-[82%]',
    useData: useChallengesData,
});
